export default {
    Feature: {
        NoteRequiredWhenCompletingActionPoint: 'Notitie vereist bij afronden actiepunt',
        ActionCoordinatorRole: 'Actiecoördinator rol',
        EmployeesMayViewDocuments: 'Medewerkers mogen documenten bekijken',
        ActionPointExecutor: 'Actiepunt uitvoerder kolom toevoegen'
    },
    OrganizationRole: {
        Admin: 'Beheerder',
        Employee: 'Medewerker'
    },
    FeatureRole: {
        ActionCoordinator: 'Actiecoördinator'
    },
    AuthRole: {
        SuperAdmin: 'Hoofdbeheerder'
    },
    EntityType: {
        Employee: 'Medewerker',
        Team: 'Team'
    }
};
